import AppPopover, { AppPopoverProps } from "../Popover/AppPopover";
import AppPopoverContent from "../Popover/AppPopoverContent";
import { GenericCalendarEntry } from "./Calendar";
import {
  CalendarMonthDayEntriesDetails,
  CalendarMonthDayEntriesDetailsProps,
} from "./CalendarMonthDayEntriesDetails";

interface Props<TEntry extends GenericCalendarEntry> extends Omit<AppPopoverProps, "children"> {
  subProps: CalendarMonthDayEntriesDetailsProps<TEntry>;
}

/** Detailed view for: month view -> day cell -> show more button -> popover. */
export function CalendarMonthDayEntriesDetailsPopover<TEntry extends GenericCalendarEntry>({
  subProps,
  ...popoverProps
}: Props<TEntry>) {
  return (
    <AppPopover {...popoverProps}>
      <AppPopoverContent sx={{ p: 0, width: { xxs: 200, md: 250 } }}>
        <CalendarMonthDayEntriesDetails {...subProps} />
      </AppPopoverContent>
    </AppPopover>
  );
}
